import React from 'react'
import { FooterContainerStyled } from './FooterStyles'

const Footer = () => {
  return (
    <FooterContainerStyled>
      <p>Movii © 2022</p>
      <p>Gustavo Bordenave</p>
    </FooterContainerStyled>
  )
}

export default Footer